import React from 'react';
import './Footer.css';

interface FooterProps {
	onPrivacyClick: () => void;
}

const Footer: React.FC<FooterProps> = ({ onPrivacyClick }) => (
	<footer className="footer">
		<div className="footer-content">
			<div className="footer-left">
				<span className="company-name">Collectors</span>
				<span className="copyright">
					© 2025 Collectors Holdings, Inc. All rights reserved.
				</span>
			</div>
			<div className="footer-right">
				<button type="button" className="footer-link">
					Terms & Conditions
				</button>
				<button type="button" className="footer-link">
					Privacy
				</button>
				<button type="button" className="footer-link">
					Help & Support
				</button>
				<button
					type="button"
					className="privacy-choices-btn"
					onClick={onPrivacyClick}
				>
					Your Privacy Choices
				</button>
			</div>
		</div>
	</footer>
);

export default Footer;
